/**
 * @generated SignedSource<<dc570dd79b10593908e230789ecbd0c4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
export type ShowClassInput = {
  classId: string;
};
export type ClassCategoriesShowClassMutation$variables = {
  input: ShowClassInput;
};
export type ClassCategoriesShowClassMutation$data = {
  readonly showClass: {
    readonly errors: ReadonlyArray<{
      readonly __typename: string;
      readonly message?: string;
    }> | null | undefined;
    readonly operationStatus: {
      readonly errors: ReadonlyArray<string | null | undefined> | null | undefined;
      readonly isSuccessful: boolean;
    } | null | undefined;
  };
};
export type ClassCategoriesShowClassMutation = {
  response: ClassCategoriesShowClassMutation$data;
  variables: ClassCategoriesShowClassMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "ShowClassPayload",
    "kind": "LinkedField",
    "name": "showClass",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "OperationStatus",
        "kind": "LinkedField",
        "name": "operationStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "isSuccessful",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "errors",
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "concreteType": null,
        "kind": "LinkedField",
        "name": "errors",
        "plural": true,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "__typename",
            "storageKey": null
          },
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "message",
                "storageKey": null
              }
            ],
            "type": "Error",
            "abstractKey": "__isError"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ClassCategoriesShowClassMutation",
    "selections": (v1/*: any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ClassCategoriesShowClassMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "e36515c714fb5e605dbe121612f87db3",
    "id": null,
    "metadata": {},
    "name": "ClassCategoriesShowClassMutation",
    "operationKind": "mutation",
    "text": "mutation ClassCategoriesShowClassMutation(\n  $input: ShowClassInput!\n) {\n  showClass(input: $input) {\n    operationStatus {\n      isSuccessful\n      errors\n    }\n    errors {\n      __typename\n      ... on Error {\n        __isError: __typename\n        message\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ae1b05e0e6ee27e3852f69f71b77d4cb";

export default node;
